import { Box, styled } from "@mui/material";

export const Legend = styled(Box)`
  align-self: flex-end;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  & > span:first-of-type {
    display: flex;
    align-items: center;
  }
`;